module.exports = __webpack_public_path__ + "static/media/vf_mshoes_core.bae6a6e0.svg";